import {BaseEntity} from "./BaseEntity";

export class SensorReading implements BaseEntity {
    constructor(
        public id?:number,
        public vTagID?:string,
        public assetName?:string,
        public created?:string,
        public sourceDistanceHops?:string,
        public tTL?:number,
        public minimumTemperatureDegC?:number,
        public maximumTemperatureDegC?:number,
        public batteryVolts?:number,
        public x?:number,
        public y?:number,
        public z?:number,
        public latitude?:number,
        public longitude?:number,
        public altitude?:number,
        public numberOfSatellites?:number,
        public lastGPSFix?:string,
        public vTagType?:string,
        public gpsAccuracy?:string,
        public parentVTag?:string,
        public locationConfidence?:string,
        public maximumAccelerationG?:number){
    }
    parseJson(json: any): void {
        this.id = json.id;
        this.vTagID = json.vTagID;
        this.assetName = json.assetName;
        this.created = json.created;
        this.sourceDistanceHops = json.sourceDistanceHops;
        this.tTL = json.ttl;
        this.minimumTemperatureDegC = json.minimumTemperatureDegC;
        this.maximumTemperatureDegC = json.maximumTemperatureDegC;
        this.batteryVolts = json.batteryVolts != null ? json.batteryVolts.toFixed(2) : null;
        this.x = json.x;
        this.y = json.y;
        this.z = json.z;
        this.latitude = json.latitude;
        this.longitude = json.longitude;
        this.altitude = json.altitude;
        this.numberOfSatellites = json.numberOfSatellites;
        this.lastGPSFix = json.lastGPSFix;
        this.vTagType = json.vTagType;
        this.gpsAccuracy = json.gpsAccuracy;
        this.parentVTag = json.parentVTag;
        this.locationConfidence = json.locationConfidence;
        this.maximumAccelerationG = json.maximumAccelerationG;
    }
}
